// @flow

import { useEffect } from 'react';
import {
  useIncomingPayment,
  getWaitBeforeRedirect,
  getRedirectUrlAfterPayment,
} from '@tectonics/prs/incoming-payment';
import { shouldRedirect } from '@tectonics/prs/incoming-payment/should-redirect';

export function useAutomaticRedirect() {
  const incomingPayment = useIncomingPayment();

  useEffect(() => {
    let timeoutId;

    if((incomingPayment.status === 'CO' || incomingPayment.status === 'PE') && shouldRedirect(incomingPayment)) {

      timeoutId = setTimeout(() => {
        window.location.assign(getRedirectUrlAfterPayment(incomingPayment));
      }, getWaitBeforeRedirect(incomingPayment) || 0);
    }

    return () => clearTimeout(timeoutId);
  }, [incomingPayment]);
}
